import Sparkline from "./Sparkline";
import { Skeleton } from "./ui";

// One metric: label, change pill, value, optional sparkline and footnote.
// While loading it renders a skeleton, never a 0.
export default function KpiCard({ label, value, pill, series, footnote, loading }) {
  return (
    <div className="flex min-w-0 flex-col gap-2.5 rounded-[14px] border border-gray-200 bg-white p-5">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[13px] font-medium text-gray-600">{label}</span>
        {!loading && pill}
      </div>
      {loading ? (
        <>
          <Skeleton className="h-8 w-24" />
          {series !== undefined && <Skeleton className="h-10 w-full" />}
          <Skeleton className="h-3 w-32" />
        </>
      ) : (
        <>
          <div className="text-3xl leading-tight font-semibold tracking-tight text-gray-900">
            {value}
          </div>
          {series !== undefined && <Sparkline values={series} />}
          {footnote && (
            <span className="text-xs leading-snug text-gray-500">{footnote}</span>
          )}
        </>
      )}
    </div>
  );
}
